
export default function Approach() {
  return (
    <section id="abordagem" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-6">
              Terapia Cognitivo-Comportamental (TCC)
            </h2>
            <div className="w-16 h-1 bg-[#B8E6D5] mb-8"></div>
            
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              A <strong className="font-medium">Terapia Cognitivo-Comportamental</strong> é uma abordagem psicoterapêutica baseada em evidências científicas, reconhecida mundialmente por sua eficácia no tratamento de diversos transtornos emocionais e comportamentais.
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Focada no presente, a TCC auxilia na identificação de pensamentos automáticos, emoções e comportamentos que podem estar causando sofrimento ou dificuldades no dia a dia.
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed mb-8">
              Através de técnicas práticas e colaborativas, você aprenderá a reconhecer e modificar padrões disfuncionais, desenvolvendo habilidades para lidar melhor com desafios emocionais e promovendo mudanças práticas e duradouras.
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#FAFAFA] p-5 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center bg-[#A8D5E2]/20 rounded-full mb-3">
                  <i className="ri-lightbulb-line text-xl text-[#A8D5E2]"></i>
                </div>
                <h3 className="text-sm font-medium text-gray-800 mb-2">Baseada em Evidências</h3>
                <p className="text-xs text-gray-600">Comprovação científica de eficácia</p>
              </div>
              
              <div className="bg-[#FAFAFA] p-5 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F4C2C2]/20 rounded-full mb-3">
                  <i className="ri-focus-line text-xl text-[#F4C2C2]"></i>
                </div>
                <h3 className="text-sm font-medium text-gray-800 mb-2">Foco no Presente</h3>
                <p className="text-xs text-gray-600">Trabalho com questões atuais</p>
              </div>
              
              <div className="bg-[#FAFAFA] p-5 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center bg-[#B8E6D5]/20 rounded-full mb-3">
                  <i className="ri-tools-line text-xl text-[#B8E6D5]"></i>
                </div>
                <h3 className="text-sm font-medium text-gray-800 mb-2">Técnicas Práticas</h3>
                <p className="text-xs text-gray-600">Ferramentas aplicáveis no cotidiano</p>
              </div>
              
              <div className="bg-[#FAFAFA] p-5 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center bg-[#E8D4A2]/20 rounded-full mb-3">
                  <i className="ri-heart-pulse-line text-xl text-[#D4AF37]"></i>
                </div>
                <h3 className="text-sm font-medium text-gray-800 mb-2">Mudanças Duradouras</h3>
                <p className="text-xs text-gray-600">Resultados consistentes e permanentes</p>
              </div>
            </div>
          </div>
          
          <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/4d5d26825a845b3a5c14aad7ac37f5b5.jpg"
              alt="Terapia Cognitivo-Comportamental"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
